import { CommonModule, KeyValue } from '@angular/common';
import { ChangeDetectorRef, Component, HostBinding, Input, OnChanges } from '@angular/core';
import { ClassicPreset } from 'rete';
import { ReteModule } from 'rete-angular-plugin/15';

/**
 * Composant générique utilisé pour le rendu d'un noeud (Noeud autre que le trigger, d'une action ou d'une étape).
 */
@Component({
    selector: 'app-custom-node',
    imports: [ReteModule, CommonModule],
    templateUrl: './custom-node.component.html',
    styleUrl: './custom-node.component.scss',
    host: {
        'data-testid': 'node',
    }
})
export class CustomNodeComponent implements OnChanges {
    /**
     * Données du noeud.
     */
    @Input() data!: ClassicPreset.Node;

    /**
     * Emet des évènements génrérés par les sockets (Input, Output) du noeud et ses contrôles.
     */
    @Input() emit!: (data: any) => void;

    /**
     * Fonction a appeler lorsque le rendu du noeud est terminé (facultatif).
     */
    @Input() rendered!: () => void;

    // TODO : verifier si necessaire
    seed = 0;

    /**
     * Obtient une valeur indiquant si le noeud est selectionné.
     * Associe cette valeur à la classe selected --> TODO : verifier si c'est toujours le cas.
     */
    @HostBinding('class.selected')
    get selected() {
        return this.data.selected;
    }

    /**
     * Constructeur.
     * @param cdr : Reference au detecteur de changement Angular.
     */
    constructor(private cdr: ChangeDetectorRef) {
        this.cdr.detach();
    }

    /**
     * Appellé lorsqu'un changement est detecté sur le composant.
     */
    ngOnChanges(): void {
        this.cdr.detectChanges();
        requestAnimationFrame(() => this.rendered());
        // TODO : verifier si necessaire
        this.seed++; // force render node
    }

    /**
     * Fonction utilisée pour trier les sockets d'input de d'output par rapport à leurs indexs
     * @param a
     * @param b
     * @returns
     */
    sortByIndex<N extends object, T extends KeyValue<string, N & { index?: number }>>(a: T, b: T) {
        const ai = a.value.index || 0;
        const bi = b.value.index || 0;

        return ai - bi;
    }
}
